<template>
    <div class="authorsection">
        <div class="authorlist">
            Joshua Pan ¹²³*, Jason J. Kwon¹²³, Jessica A. Talamas¹²³, Ashir A. Borah², Francisca Vazquez², Jesse S. Boehm², Aviad Tsherniak², Marinka Zitnik²⁴⁵, James M. McFarland², William C. Hahn¹²³⁶ *
        </div>
        <br>
        <ol>
            <li>Dana-Farber Cancer Institute, Department of Medical Oncology, Boston, MA</li>
            <li>Broad Institute of MIT and Harvard, Cambridge, MA</li>
            <li>Harvard Medical School, Boston, MA</li>
            <li>Harvard Medical School, Department of Biomedical Informatics, Boston, MA</li>
            <li>Harvard University, Data Science Initiative, Cambridge, MA</li>
            <li>Brigham and Women’s Hospital and Harvard Medical School, Department of Medicine, Boston, MA</li>
        </ol>
        <h5><b>*</b> Lead contact: William_Hahn@dfci.harvard.edu</h5>
    </div>
</template>

<script>
    export default {
        name: "Authors"
    }
</script>

<style scoped>
    p {
        color: black;
        padding: 10px
    }

    ol {
        margin-bottom: 0px;
    }

    li {
      font-size: 14px;
      line-height: 1.6em;
      margin-bottom: 0px;
    }

    .authorlist{
    font-size: 20px;  
    font-weight: 400;
    margin-top: 20px;
    margin-bottom: 0px;
    line-height: 1.2em; 
    }

    .authorsection {
        margin-bottom: 40px;
    }       

</style>